<template>
  <app-common-layout title="Top">
    <template #header>
    </template>
    <div class="mx-10 mt-0 font-iroha text-base md:text-xl">
      <div class="sm:grid sm:grid-cols-8 sm:place-items-center">
        <div class="sm:col-span-3 mb-10 sm:mb-0 mt-0 md:px-5">
          <div class="text-CLIENT_PRIMARY_PINK flex justify-center">
            <ul>
              <li>
                <div class="inline-block">
                  <a
                    class="mt-0 flex hover:-translate-y-2 transition duration-500"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.rinshovet.blog/">
                    <img
                      class="w-7 h-7"
                      src="/images/terakoya-icon.png" />
                    <div class="ml-5">
                      <span class=""> オンライン予備校(寺子屋)勉強会 </span>
                      <span class="block text-xs md:text-sm sm:text-base text-gray-500">
                        〜山下先生監修〜
                      </span>
                    </div>
                  </a>
                </div>
                <div
                  v-if="isFetchedUserInfo && isLoggedIn"
                  class="mt-4">
                  <div
                    v-if="!isVerifiedEmail"
                    class="font-sans text-base text-red-500">
                    <p>※メールアドレスが認証されていません。</p>
                    <p>購読するには認証が必要となります。</p>
                    <button
                      class="text-white text-center text-base bg-CLIENT_PRIMARY_PINK rounded-xl p-2 hover:bg-CLIENT_PRIMARY_PINK_HOVER duration-500"
                      @click.prevent="sendVerificationEmail">
                      認証メール再送信
                    </button>
                  </div>

                  <div
                    v-else
                    class="text-white md:ml-12 text-sm md:text-base">
                    <a
                      v-if="isStripeSubscription"
                      class="bg-gray-300 rounded-xl p-2 cursor-not-allowed">
                      購読中
                    </a>
                    <button
                      v-else-if="!isMobileSubscription"
                      class="bg-CLIENT_PRIMARY_PINK hover:bg-CLIENT_PRIMARY_PINK_HOVER duration-500 rounded-xl p-2"
                      @click="subscription">
                      購読する
                    </button>
                    <a
                      v-if="customerPortalUrl"
                      class="text-CLIENT_PRIMARY_PINK border-2 border-CLIENT_PRIMARY_PINK ml-2 hover:bg-gray-100 duration-500 rounded-xl p-2"
                      :href="customerPortalUrl">購読内容確認
                    </a>
                    <div
                      v-if="isStripeSubscription || isMobileSubscription"
                      class="mt-4">
                      <button
                        class="text-CLIENT_PRIMARY_PINK border-2 border-CLIENT_PRIMARY_PINK hover:bg-gray-100 duration-500 rounded-xl p-2"
                        @click="resendTerakoyaPassword">
                        オンライン予備校(寺子屋)パスワード再発行
                      </button>
                    </div>
                  </div>
                </div>
              </li>

              <li>
                <div class="inline-block">
                  <a
                    class="mt-10 flex hover:-translate-y-2 transition duration-500"
                    target="_blank"
                    rel="noopener noreferrer"
                    :href="route('client-top')">
                    <img
                      class="w-7 h-7"
                      src="/images/exam-icon.png" />
                    <div class="ml-5">
                      <span class=""> オンライン模試サービス </span>
                      <span class="block text-xs md:text-sm sm:text-base text-gray-500">
                        〜擬似国家試験〜
                      </span>
                    </div>
                  </a>
                </div>
              </li>

              <li>
                <div class="inline-block">
                  <a
                    class="mt-10 flex hover:-translate-y-2 transition duration-500"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://apps.apple.com/jp/app/%E3%81%A9%E3%81%86%E3%81%B6%E3%81%A4%E7%9C%8B%E8%AD%B7%E3%83%9D%E3%83%BC%E3%82%BF%E3%83%AB/id1628987767">
                    <img
                      class="w-7 h-7 object-contain"
                      src="/images/portal-icon.png" />
                    <div class="ml-5">
                      <span class=""> どうぶつ看護ポータル(iOS) </span>
                      <span class="block text-xs md:text-sm sm:text-base text-gray-500">
                        〜いつでもどこでも学習〜
                      </span>
                    </div>
                  </a>
                </div>
              </li>

              <li>
                <div class="inline-block">
                  <a
                    class="mt-10 flex hover:-translate-y-2 transition duration-500"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://play.google.com/store/apps/details?id=com.vet.animal_portal&pli=1">
                    <img
                      class="w-7 h-7 object-contain"
                      src="/images/portal-icon.png" />
                    <div class="ml-5">
                      <span class=""> どうぶつ看護ポータル(Android) </span>
                      <span class="block text-xs md:text-sm sm:text-base text-gray-500">
                        〜いつでもどこでも学習〜
                      </span>
                    </div>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="sm:col-span-5 w-full">
          <carousel
            :items-to-show="1"
            autoplay="4000"
            wrap-around="true">
            <slide key="1">
              <img
                class="w-auto"
                src="/images/top-image.webp" />
            </slide>
            <slide key="2">
              <img
                class="w-auto"
                src="/images/terakoya-hp.png" />
            </slide>

            <template #addons>
              <navigation />
              <pagination />
            </template>
          </carousel>
        </div>
      </div>

      <div class="mt-20 sm:flex sm:justify-center">
        <div
          class="pt-5 px-5 sm:w-screen sm:max-w-2xl text-CLIENT_PRIMARY_PINK shadow overflow-hidden rounded-md sm:flex">
          <div class="justify-items-start mb-5 sm:mb-0">
            <button @click.prevent="onClickInformationList">
              <span>お知らせ</span>
            </button>
          </div>

          <div class="font-sans text-xs md:text-sm sm:text-base sm:ml-5">
            <button
              v-for="(information, i) in informationList"
              :key="i"
              class="mb-5 block"
              @click.prevent="onClickInformation(information.id)">
              {{ moment(`${information.created_at}`).format('YYYY.MM.DD') }} {{ information.subject }}
            </button>
          </div>
        </div>
      </div>

      <div class="flex justify-center my-10">
        <a
          class=""
          target="_blank"
          rel="noopener noreferrer"
          href="https://and-vet.com/">
          <img
            class="w-56 mr-5"
            src="/images/andvet-hp.png" />
        </a>
        <a
          class=""
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.qnote.co.jp/">
          <img
            class="w-56 ml-5"
            src="/images/qnote-hp.png" />
        </a>
      </div>
    </div>
  </app-common-layout>
</template>

<script setup>
import {
  sendEmailVerification,
} from 'firebase/auth'
import moment from 'moment'
import { ref, computed } from 'vue'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import { Inertia } from '@inertiajs/inertia'
import AppCommonLayout from '@/Layouts/AppCommonLayout'
import 'vue3-carousel/dist/carousel.css'
import {
  Carousel, Slide, Pagination, Navigation,
} from 'vue3-carousel'
import Swal from 'sweetalert2'
import firebaseApp from '@/Constants/configFirebase'

const props = defineProps({
  informationList: {
    type: Array,
    default: () => [],
  },
  isStripeSubscription: {
    type: Boolean,
    default: () => false,
  },
  isMobileSubscription: {
    type: Boolean,
    default: () => false,
  },
  customerPortalUrl: {
    type: String,
    default: () => '',
  },
})

const isLoggedIn = ref(false)
const user = ref()
const isFetchedUserInfo = ref(false)

firebase.auth(firebaseApp).onAuthStateChanged((e) => {
  if (e) {
    isLoggedIn.value = true
    user.value = e
  } else {
    isLoggedIn.value = false
    user.value = null
  }
  isFetchedUserInfo.value = true
})

const isVerifiedEmail = computed(() => user.value.emailVerified)

const subscription = () => {
  Inertia.post(route('client.subscription', {
    price_id: process.env.MIX_STRIPE_TERAKOYA_PRICE_ID,
  }))
}

const openCustomerPortal = () => {
  Inertia.get(route('portal.customer.portal'))
}

const onClickInformationList = () => {
  Inertia.get(route('portal.information.index'))
}

const onClickInformation = (information) => {
  Inertia.get(route('portal.information.show', {
    information,
  }))
}

// パスワードリセット後のリダイレクト先
const actionCodeSettings = {
  url: route('index'),
}

const sendVerificationEmail = async () => {
  Swal.fire({
    icon: 'question',
    html: `認証用のメールを再発行しますか？<br>${user.value.email}`,
    showCancelButton: true,
    confirmButtonText: 'はい',
    cancelButtonText: 'いいえ',
    confirmButtonColor: '#FF8A80',
  }).then(async (result) => {
    if (result.isConfirmed) {
      await sendEmailVerification(user.value, actionCodeSettings).then(() => {
        Swal.fire({
          html: '認証用メールを送信しました。<br>メールをご確認ください。',
          icon: 'success',
          confirmButtonText: '閉じる',
        })
      }).catch((e) => {
        if (e.code == 'auth/too-many-requests') {
          Swal.fire({
            text: '時間をあけて再度お試しください。',
            icon: 'warning',
            confirmButtonText: '閉じる',
          })
        } else {
          Swal.fire({
            text: e.code,
            icon: 'warning',
            confirmButtonText: '閉じる',
          })
        }
      })
    }
  })
}

const resendTerakoyaPassword = () => {
  Swal.fire({
    icon: 'question',
    text: 'オンライン予備校(寺子屋)のパスワードをメールで再発行しますか？',
    showCancelButton: true,
    confirmButtonText: 'はい',
    cancelButtonText: 'いいえ',
    confirmButtonColor: '#FF8A80',
  }).then((result) => {
    if (result.isConfirmed) {
      Inertia.post(route('client.resend.terakoya.password'))
    }
  })
}

</script>
